import React, { useMemo } from 'react';
import PickupCategoryApi from '../PickupCategoryApi';
import PickupCategorySettings from '../PickupCategorySettings';
import DropMenu from '@dex/bubl-dash/src/lib/components/DropMenu/DropMenu';
import Link from '@dex/bubl-dash/src/lib/components/Link/Link';

const PickupCategoryActions: React.FC<any> = (props: any) => {

    const { data } = props;

    const del = PickupCategoryApi.delete(data.id, {
        onComplete: (response) => {

            if (data.modelName && data.id) {
                const event = new CustomEvent(data.modelName + data.id, { detail: 'deleted' });
                window.dispatchEvent(event);
            }

        }
    });

    return useMemo(() => {

        return (

            <DropMenu>

                <Link
                    path={`${ PickupCategorySettings.path }/${data.id}/view`}
                >
                    View
                </Link>

                <Link
                    path={`${ PickupCategorySettings.path }/${data.id}/edit`}
                >
                    Edit
                </Link>

                <Link
                    confirm={ {
                        title: `Delete ${ data[PickupCategorySettings.primaryKey] }`,
                        message: "Are your sure you want to perform this action?"
                    } }
                    onClick={del.run}
                >
                    Delete
                </Link>

            </DropMenu>

        )

    }, [data, del]);

}

export default PickupCategoryActions;
